import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { REACT_QUERY_AI_USAGES_QUERY_KEY } from '../constants';
import aiUsagesUseCase from '../factories/aiUsages';

export const useGetAiUsages = (options = {}) => {
  const query = useQuery(
    [REACT_QUERY_AI_USAGES_QUERY_KEY],
    () => aiUsagesUseCase.getAiUsages(),
    options
  );

  return query;
};

export const useAiUsage = (options = {}) => {
  const { data, refetch } = useGetAiUsages(options);

  const aiUsage = useMemo(() => {
    const result = data?.aiUsages?.find((u) => u.type === 'AI_USAGE');
    if (!result) return null;
    return {
      used: result.used,
      limit: result.limit,
      isAtLimit: result.used >= result.limit,
    };
  }, [data]);

  return { aiUsage, refetchUsages: refetch };
};
